export default () => {
  // Function to remove !important from .hidden class
  function removeImportantFromHiddenClass() {
    // Loop through all stylesheets
    for (let sheet of document.styleSheets) {
      try {
        // Loop through all CSS rules in the stylesheet
        for (let i = 0; i < sheet.cssRules.length; i++) {
          const rule = sheet.cssRules[i];
          // Check if it's the .hidden rule
          if (rule.selectorText === ".hidden") {
            sheet.deleteRule(i);
            sheet.insertRule(".hidden { display: none; }", i);
          }
        }
      } catch (e) {
        // Catch potential CORS errors or inaccessible stylesheets
        console.warn("Could not access stylesheet:", e);
      }
    }
  }

  // Run the function immediately on page load
  removeImportantFromHiddenClass();

  const observer = new MutationObserver(() => {
    const modalElement = document.querySelector(".w3a-modal");
    if (modalElement) {
      document.querySelectorAll("button").forEach((button) => {
        button.removeAttribute("title");
      });
    }
  });

  // Start observing the body for Web3Auth modal appearance
  observer.observe(document.body, { childList: true, subtree: true });
};
